import React, { useCallback, useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash.debounce'
import { TextArea, TextField } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'

export default function EditableField({ editing, value, onDebounce, ElseElement, label, multiValue, error, helpText }) {
  const [tempValue, setTempValue] = useState(() => value)

  useEffect(() => {
    setTempValue(value)
  }, [value])

  const doDebounceFn = useMemo(
    () =>
      debounce(
        (param) => {
          if (typeof onDebounce === 'function') {
            onDebounce(param)
          }
        },
        100,
        { leading: false, trailing: true }
      ),
    [onDebounce]
  )

  const handleInput = useCallback(
    (v) => {
      const val = v.target.value
      setTempValue(val)
      doDebounceFn(val)
    },
    [doDebounceFn]
  )

  return (
    <>
      {editing ? (
        <>
          {multiValue ? (
            <TextArea label={label} value={tempValue} rows={2} onInput={handleInput} helpMessage={helpText} />
          ) : (
            <TextField
              label={label}
              value={tempValue}
              onInput={handleInput}
              errorMessage={error && <div>{i18n.t('editableFieldError', 'This Field did not save correctly')}</div>}
            />
          )}
        </>
      ) : (
        ElseElement
      )}
    </>
  )
}

EditableField.propTypes = {
  editing: PropTypes.bool,
  ElseElement: PropTypes.node.isRequired,
  label: PropTypes.string,
  multiValue: PropTypes.bool,
  onDebounce: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.bool,
}
